module.exports = __webpack_public_path__ + "static/media/1009845.57e84cb0.jpg";